import { demoBookings } from '@/mocks/demoData';
import type { Booking } from '@/mocks/data';

let bookings: Booking[] = [...demoBookings];

export function getBookings(): Booking[] {
  return bookings;
}

export function getBookingById(id: string): Booking | undefined {
  return bookings.find((b) => b.id === id);
}

export function getBookingByBookingId(bookingId: string): Booking | undefined {
  return bookings.find((b) => b.booking_id === bookingId);
}

export function updateBooking(id: string, updates: Partial<Booking>): void {
  bookings = bookings.map((b) => (b.id === id ? { ...b, ...updates } : b));
}

export function addBooking(booking: Booking): void {
  bookings = [booking, ...bookings];
}

export function reducePendingAmount(bookingId: string, amount: number): void {
  bookings = bookings.map((b) => {
    if (b.id === bookingId) {
      return { ...b, pending_amount: Math.max(0, b.pending_amount - amount) };
    }
    return b;
  });
}

export function increasePendingAmount(bookingId: string, amount: number): void {
  bookings = bookings.map((b) => {
    if (b.id === bookingId) {
      return { ...b, pending_amount: b.pending_amount + amount };
    }
    return b;
  });
}

export function getPendingBookings(): Booking[] {
  return bookings.filter((b) => b.pending_amount > 0 && ['checked_in', 'confirmed'].includes(b.status));
}

export function getCheckedInBookings(): Booking[] {
  return bookings.filter((b) => b.status === 'checked_in');
}